document.addEventListener("DOMContentLoaded", function () {
  const productAccordionItems = document.querySelectorAll(
    ".product-desc_accordion_item",
  );

  productAccordionItems.forEach((item) => {
    const header = item.querySelector("[data-accordion-header]");
    const body = item.querySelector("[data-accordion-body]");

    header.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const isOpen = item.classList.contains("open");

      // Close all
      productAccordionItems.forEach((i) => {
        i.classList.remove("open");
        i.querySelector("[data-accordion-body]").style.maxHeight = "0px";
      });

      // Open clicked if it wasn’t open
      if (!isOpen) {
        item.classList.add("open");
        body.style.maxHeight = body.scrollHeight + "px";
      }
    });
  });
});
